var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2161 2.0927C14.8256 1.70217 14.1925 1.70217 13.8019 2.0927L7.43797 8.45666C7.04744 8.84718 7.04744 9.48035 7.43797 9.87087C7.82849 10.2614 8.46165 10.2614 8.85218 9.87087L14.509 4.21402L20.1659 9.87087C20.5564 10.2614 21.1896 10.2614 21.5801 9.87087C21.9706 9.48035 21.9706 8.84718 21.5801 8.45666L15.2161 2.0927ZM13.8019 25.9069C14.1925 26.2974 14.8256 26.2974 15.2161 25.9069L21.5801 19.5429C21.9706 19.1524 21.9706 18.5193 21.5801 18.1287C21.1896 17.7382 20.5564 17.7382 20.1659 18.1287L14.509 23.7856L8.85218 18.1287C8.46165 17.7382 7.82849 17.7382 7.43797 18.1287C7.04744 18.5193 7.04744 19.1524 7.43797 19.5429L13.8019 25.9069ZM13.509 2.7998V25.1998H15.509V2.7998H13.509Z",
    fill: "#4F84E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.a91238ede6d2ac6d9132f517cb8e84b5.svg";
export { ForwardRef as ReactComponent };